import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import {
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  DestroyRef,
  inject,
  makeStateKey,
  OnInit,
  REQUEST
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';
import { isMobileDevice, loadSalesIQ } from '@repo/ui/lib/salesiq';
import { filter, take } from 'rxjs';
import { BaseWidget } from './widgets/base-widget/base-widget';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseWidget implements OnInit {
  private readonly request = inject(REQUEST, { optional: true });
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    super();
  }

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      this.transferState.set(makeStateKey(this.ua), this.request?.headers['user-agent'] ?? '');
    }

    if (isPlatformBrowser(this.platformId) && !this.shouldSkipHydration()) {
      // Wait for the session to resolve, then load SalesIQ unless the user is an
      // assisted-sales session (or on mobile).
      this.apiService.isAssistedUser$
        .pipe(
          filter((isAssisted) => isAssisted !== null),
          take(1),
          takeUntilDestroyed(this.destroyRef),
        )
        .subscribe((isAssisted) => {
          if (!isAssisted && !isMobileDevice()) {
            loadSalesIQ();
          }
        });
    }
  }
}
